module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course"
  }, [_c('el-col', {
    staticClass: "course-categories",
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "course-category",
    class: _vm.courseCategory === 0 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(0)
      }
    }
  }, [_vm._v("\n                必修課\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "course-category",
    class: _vm.courseCategory === 1 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(1)
      }
    }
  }, [_vm._v("\n                選修課\n            ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "course-title"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', [_vm._v("\n                        " + _vm._s(_vm.categoryTitle) + " \n                    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-cascader', {
    staticClass: "menu-select",
    attrs: {
      "placeholder": "",
      "show-all-levels": false,
      "options": _vm.actualDepsOptions
    },
    on: {
      "change": _vm.handleActualDepSelect
    },
    model: {
      value: (_vm.selectedDepId),
      callback: function($$v) {
        _vm.selectedDepId = $$v
      },
      expression: "selectedDepId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "course-content"
  }, [(_vm.courseCategory === 0) ? _c('el-row', [_c('CourseType', {
    key: _vm.refreshKey,
    attrs: {
      "courseType": 1,
      "selectedDepId": _vm.selectedDepId
    }
  })], 1) : (_vm.courseCategory === 1) ? _c('el-row', [_c('CourseType', {
    key: _vm.refreshKey,
    attrs: {
      "courseType": 0,
      "selectedDepId": _vm.selectedDepId
    }
  })], 1) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33ac8688"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Course.vue
// module id = 916
// module chunks = 170